module.exports = __webpack_public_path__ + "img/141.7.3c7619f5.png";